<template>
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-900 to-blue-800">
    <!-- Main Card -->
    <div class="bg-white p-10 rounded-2xl shadow-2xl w-full max-w-md mx-4">
      <!-- Header with Logo -->
      <!-- <div class="flex flex-col items-center mb-8"> -->
        <!-- <div class="w-16 h-16 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full flex items-center justify-center mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4" />
          </svg>
        </div> -->
        <!-- <h1 class="text-2xl font-bold text-gray-800">{{ t('app.name') }}</h1> -->
      <!-- </div> -->

      <!-- Login Form -->
      <Transition name="fade" mode="out-in">
        <div v-if="!isLogin" class="space-y-6">
          <h2 class="text-2xl font-bold text-center text-gray-800">{{ t('login.title') }}</h2>
          <form @submit.prevent="handleLogin" class="space-y-5">
            <div class="space-y-2">
              <label for="email" class="block text-sm font-medium text-gray-700">{{ t('login.email') }}</label>
              <div class="relative">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <input
                  v-model="loginForm.email"
                  type="email"
                  id="email"
                  :placeholder="t('login.placeholderEmail')"
                  class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                />
              </div>
            </div>
            <div class="space-y-2">
              <label for="password" class="block text-sm font-medium text-gray-700">{{ t('login.password') }}</label>
              <div class="relative">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                  </svg>
                </div>
                <input
                  v-model="loginForm.password"
                  :type="showPassword ? 'text' : 'password'"
                  id="password"
                  :placeholder="t('login.placeholderPassword')"
                  class="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                />
                <button
                  type="button"
                  @click="showPassword = !showPassword"
                  class="absolute inset-y-0 right-0 pr-3 flex items-center"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path v-if="showPassword" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                    <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                </button>
              </div>
            </div>
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <input
                  id="remember-me"
                  name="remember-me"
                  type="checkbox"
                  class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label for="remember-me" class="ml-2 block text-sm text-gray-700">
                  {{ t('signup.rememberMe') }}
                </label>
              </div>
              <div class="text-sm">
                <!-- <a href="#" class="font-medium text-blue-600 hover:text-blue-500">
                  {{ t('login.forgotPassword') }}
                </a> -->
              </div>
            </div>
            <button
              type="submit"
              :disabled="isLoading"
              class="w-full mt-2 px-4 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-medium rounded-xl hover:from-blue-700 hover:to-indigo-700 transition duration-300 flex items-center justify-center"
            >
              <span v-if="!isLoading">{{ t('login.buttonText') }}</span>
              <svg v-if="isLoading" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </button>
          </form>
          <div class="relative">
            <div class="absolute inset-0 flex items-center">
              <div class="w-full border-t border-gray-300"></div>
            </div>
            <!-- <div class="relative flex justify-center text-sm">
              <span class="px-2 bg-white text-gray-500">
                {{ t('login.socialLogin') }}
              </span>
            </div> -->
          </div>
          <!-- <div class="grid grid-cols-2 gap-3">
            <button
              type="button"
              class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-xl shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
            >
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                <path fill-rule="evenodd" d="M10 0C4.477 0 0 4.477 0 10c0 4.42 2.865 8.166 6.839 9.489.5.092.682-.217.682-.482 0-.237-.008-.866-.013-1.7-2.782.603-3.369-1.342-3.369-1.342-.454-1.155-1.11-1.462-1.11-1.462-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.269 2.75 1.025A9.564 9.564 0 0110 4.844c.85.004 1.705.114 2.504.336 1.909-1.294 2.747-1.025 2.747-1.025.546 1.377.203 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.933.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48C17.14 18.163 20 14.418 20 10c0-5.523-4.477-10-10-10z" clip-rule="evenodd" />
              </svg>
            </button>
            <button
              type="button"
              class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-xl shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
            >
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                <path fill-rule="evenodd" d="M10 0C4.477 0 0 4.477 0 10c0 5.523 4.477 10 10 10 5.523 0 10-4.477 10-10 0-5.523-4.477-10-10-10zm3 8a3 3 0 11-6 0 3 3 0 016 0zm-9.735 4.322a6.966 6.966 0 01-.98-3.322c0-1.023.18-2.004.508-2.91h2.025a8.94 8.94 0 00-.033 5.232H3.265zm6.735 2.678a6.966 6.966 0 01-3.322-.98v-2.025a8.94 8.94 0 005.232.033v2.025c-.906.328-1.887.508-2.91.508zm2.678-6.735a6.966 6.966 0 01-.98 3.322h-2.025a8.94 8.94 0 00.033-5.232h2.025c.328.906.508 1.887.508 2.91zm-3.322-6.735a6.966 6.966 0 013.322-.98v2.025a8.94 8.94 0 00-5.232-.033V3.265c.906-.328 1.887-.508 2.91-.508z" clip-rule="evenodd" />
              </svg>
            </button>
          </div> -->
          <p class="text-center text-sm text-gray-600">
            {{ t('login.noAccount') }}
            <a @click="toggleForm" class="font-medium text-blue-600 hover:text-blue-500 cursor-pointer">{{ t('login.signup') }}</a>
          </p>
        </div>

        <!-- Signup Form -->
        <div v-else class="space-y-6">
          <h2 class="text-2xl font-bold text-center text-gray-800">{{ t('signup.title') }}</h2>
          <form @submit.prevent="handleSignup" class="space-y-5">
            <div class="space-y-2">
              <label for="name" class="block text-sm font-medium text-gray-700">{{ t('signup.name') }}</label>
              <div class="relative">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <input
                  v-model="signupForm.name"
                  type="text"
                  id="name"
                  :placeholder="t('signup.placeholderName')"
                  class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                />
              </div>
            </div>
            <div class="space-y-2">
              <label for="email" class="block text-sm font-medium text-gray-700">{{ t('signup.email') }}</label>
              <div class="relative">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <input
                  v-model="signupForm.email"
                  type="email"
                  id="email"
                  :placeholder="t('signup.placeholderEmail')"
                  class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                />
              </div>
            </div>
            <div class="space-y-2">
              <label for="password" class="block text-sm font-medium text-gray-700">{{ t('signup.password') }}</label>
              <div class="relative">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                  </svg>
                </div>
                <input
                  v-model="signupForm.password"
                  :type="showPassword ? 'text' : 'password'"
                  id="password"
                  :placeholder="t('signup.placeholderPassword')"
                  class="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                  @input="checkPasswordStrength"
                />
                <button
                  type="button"
                  @click="showPassword = !showPassword"
                  class="absolute inset-y-0 right-0 pr-3 flex items-center"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path v-if="showPassword" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                    <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                </button>
              </div>
              <div class="mt-1">
                <div class="flex items-center">
                  <div class="w-full bg-gray-200 rounded-full h-2">
                    <div 
                      class="h-2 rounded-full" 
                      :class="{
                        'bg-red-500': passwordStrength === 0,
                        'bg-yellow-500': passwordStrength === 1,
                        'bg-blue-500': passwordStrength === 2,
                        'bg-green-500': passwordStrength === 3
                      }"
                      :style="{ width: passwordStrength === 0 ? '25%' : passwordStrength === 1 ? '50%' : passwordStrength === 2 ? '75%' : '100%' }"
                    ></div>
                  </div>
                  <span class="ml-2 text-xs text-gray-500">
                    {{ passwordStrengthText }}
                  </span>
                </div>
              </div>
            </div>
            <div class="space-y-2">
              <label for="password_confirmation" class="block text-sm font-medium text-gray-700">{{ t('signup.passwordConfirmation') }}</label>
              <div class="relative">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                  </svg>
                </div>
                <input
                  v-model="signupForm.password_confirmation"
                  type="password"
                  id="password_confirmation"
                  :placeholder="t('signup.placeholderConfirmPassword')"
                  class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                />
              </div>
            </div>
            <button
              type="submit"
              :disabled="isLoading"
              class="w-full mt-2 px-4 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-medium rounded-xl hover:from-blue-700 hover:to-indigo-700 transition duration-300 flex items-center justify-center"
            >
              <span v-if="!isLoading">{{ t('signup.buttonText') }}</span>
              <svg v-if="isLoading" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </button>
          </form>
          <p class="text-center text-sm text-gray-600">
            {{ t('signup.alreadyAccount') }}
            <a @click="toggleForm" class="font-medium text-blue-600 hover:text-blue-500 cursor-pointer">{{ t('signup.login') }}</a>
          </p>
        </div>
      </Transition>
    </div>

    <!-- Modern Modal -->
    <Transition name="modal">
      <div v-if="showModal" class="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div class="fixed inset-0 bg-black bg-opacity-50 transition-opacity" @click="closeModal"></div>
        <div class="relative bg-white rounded-2xl shadow-xl max-w-md w-full transform transition-all">
          <div class="p-6">
            <div class="flex items-start justify-between">
              <div class="flex items-center">
                <div v-if="isError" class="flex-shrink-0 h-10 w-10 rounded-full bg-red-100 flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                </div>
                <div v-else class="flex-shrink-0 h-10 w-10 rounded-full bg-green-100 flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <h3 class="ml-3 text-lg font-medium text-gray-900">
                  {{ isError ? t('modal2.errorSignup') : t('modal2.successSignup') }}
                </h3>
              </div>
              <button @click="closeModal" class="text-gray-400 hover:text-gray-500">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div class="mt-4">
              <p class="text-sm text-gray-600">{{ modalMessage }}</p>
            </div>
            <div class="mt-5 sm:mt-6">
              <button
                type="button"
                @click="closeModal"
                class="w-full inline-flex justify-center rounded-xl border border-transparent shadow-sm px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-base font-medium text-white hover:from-blue-700 hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm transition duration-300"
              >
                {{ t('modal2.close') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import axios from 'axios'; // Import axios
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { API_BASE_URL } from '@/apiConfig'; // Import the base URL

const router = useRouter();
const { t, locale } = useI18n();

// Form state
const isLogin = ref(true);
const loginForm = ref({ email: '', password: '' });
const signupForm = ref({ name: '', email: '', password: '', password_confirmation: '' });

// UI state
const showModal = ref(false);
const modalMessage = ref('');
const isError = ref(false);
const isLoading = ref(false);
const showPassword = ref(false);
const passwordStrength = ref(0);

// Password strength checker
const checkPasswordStrength = () => {
  const password = signupForm.value.password;
  if (!password) {
    passwordStrength.value = 0;
    return;
  }

  let strength = 0;
  if (password.length >= 8) strength++;
  if (/[A-Z]/.test(password)) strength++;
  if (/[0-9]/.test(password)) strength++;
  if (/[^A-Za-z0-9]/.test(password)) strength++;

  passwordStrength.value = Math.min(strength, 3);
};

const passwordStrengthText = computed(() => {
  const texts = [
    t('signup.passwordStrength.weak'),
    t('signup.passwordStrength.fair'),
    t('signup.passwordStrength.good'),
    t('signup.passwordStrength.strong'),
  ];
  return texts[passwordStrength.value];
});

const toggleForm = () => {
  isLogin.value = !isLogin.value;
  // Reset forms when toggling
  loginForm.value = { email: '', password: '' };
  signupForm.value = { name: '', email: '', password: '', password_confirmation: '' };
  passwordStrength.value = 0;
};

// Handle login
const handleLogin = async () => {
  isLoading.value = true;
  try {
    const response = await axios.post(`${API_BASE_URL}/login`, {
      email: loginForm.value.email,
      password: loginForm.value.password,
    });
    // Save token and user data to localStorage
    localStorage.setItem('token', response.data.token);
    localStorage.setItem('user', JSON.stringify(response.data.user));

    isError.value = false;
    modalMessage.value = t('modal2.successLogin');
    router.push('/'); // Redirect to home page
    window.location.reload(); // Reload the page
  } catch (error) {
    isError.value = true;
    modalMessage.value = error.response?.data?.message || t('modal2.errorLogin');
  } finally {
    showModal.value = true;
    isLoading.value = false;
  }
};

// Handle signup
const handleSignup = async () => {
  if (signupForm.value.password !== signupForm.value.password_confirmation) {
    isError.value = true;
    modalMessage.value = t('modal2.passwordMismatch');
    showModal.value = true;
    return;
  }

  isLoading.value = true;
  try {
    const response = await axios.post(`${API_BASE_URL}/register`, {
      name: signupForm.value.name,
      email: signupForm.value.email,
      password: signupForm.value.password,
      password_confirmation: signupForm.value.password_confirmation,
    });
    // Save token and user data to localStorage
    localStorage.setItem('token', response.data.token);
    localStorage.setItem('user', JSON.stringify(response.data.user));

    isError.value = false;
    modalMessage.value = t('modal2.successSignup');
    // router.push('/'); // Redirect to home page
    // window.location.reload(); // Reload the page
    history.back();
  } catch (error) {
    isError.value = true;
    modalMessage.value = error.response?.data?.message || t('modal2.errorSignup');
  } finally {
    showModal.value = true;
    isLoading.value = false;
  }
};

const closeModal = () => {
  showModal.value = false;
};

// Set language from localStorage on page load
onMounted(() => {
  const lang = localStorage.getItem('lang') || 'en';
  locale.value = lang;
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.modal-enter-active,
.modal-leave-active {
  transition: all 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>